import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import React from 'react';
import { getI18NMessage } from './../../../i18n/I18N';
import UI_CONSTANTS from '../../app/constants/UIConstants';

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            isValidLink: false,
            newPasswordVisibily: false,
            confirmPpasswordVisibily: false,
            doNotMatchPasswordError: '',
            minPasswordCharError: ''
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.showPassword = this.showPassword.bind(this);
        this.hidePassword = this.hidePassword.bind(this);
    }

    componentDidMount() {
        this.props.validResetLink((response => {
            this.setState({
                isLoaded: true,
                isValidLink: response.valid,
                realm: response.realm,
                userId: response.userId,
                accountId: response.accountId,
                username: response.username,
                slug: response.slug,
                env: response.env,
                app: response.app,
                resetLinkId: response.resetLinkId
            })
        }));
    }

    render() {
        if ( !this.state.isLoaded ) {
            return false;
        }

        const { isValidLink, newPasswordVisibily, confirmPpasswordVisibily, 
            doNotMatchPasswordError, minPasswordCharError } = this.state;
        const enableSubmit = (this.state.password || '').trim() && (this.state.confirmpassword || '').trim();
        const visiblePasswordProps = {
            InputProps: {
                endAdornment: <Visibility onClick={ this.hidePassword } />
            }
        }
        const hiddenPasswordProps = {
            type: 'password',
            InputProps: {
                endAdornment: <VisibilityOff onClick={ this.showPassword } />
            }
        }
        const newPasswordProps = newPasswordVisibily ? visiblePasswordProps : hiddenPasswordProps;
        const confirmPasswordProps = confirmPpasswordVisibily ? visiblePasswordProps : hiddenPasswordProps;

        return (
            <React.Fragment>
                {
                    <span className='fgt-pws-header'>{ getI18NMessage( isValidLink ? 'resetpassword' : 'linkexpired') }</span>
                }
                {
                    !isValidLink && 
                    <>
                        {getI18NMessage('newlinkinfo')}
                        <a href={ UI_CONSTANTS.FORGOT_PW_URL_HASH }>Click here to generate new link</a>
                    </>
                }
                {
                    isValidLink &&
                        <form id='sso-form-resetpassword' onSubmit={ this.onSubmit }
                            action='/rest/v1/users/resetpassword' method="post" >
                            <FormControl className='lg-rpwd-field'>
                                <TextField size='small' label={ getI18NMessage('newpassword') } 
                                    name='password' fullWidth autoFocus
                                    onChange={ this.onInputChange } onBlur={ this.onInputChange } 
                                    { ...newPasswordProps }
                                />
                                {
                                    minPasswordCharError &&
                                        <FormHelperText>{ getI18NMessage(minPasswordCharError) }</FormHelperText>
                                }
                            </FormControl>
                            <FormControl className='lg-rpwd-field'>
                                <TextField size='small' label={ getI18NMessage('confirmpassword') } 
                                    name='confirmpassword' fullWidth 
                                    onChange={ this.onInputChange } onBlur={ this.onInputChange } 
                                    { ...confirmPasswordProps }
                                />
                                {
                                    doNotMatchPasswordError &&
                                        <FormHelperText>{ getI18NMessage(doNotMatchPasswordError) }</FormHelperText>
                                }
                            </FormControl>
                            <TextField name='realmId' value={ this.state.realm } type='hidden' className='lg-hidden-field' />
                            <TextField name='accountId' value={ this.state.accountId } type='hidden' className='lg-hidden-field' />
                            <TextField name='userId' value={ this.state.userId } type='hidden' className='lg-hidden-field' />
                            <TextField name='username' value={ this.state.username } type='hidden' className='lg-hidden-field' />
                            <TextField name='slug' value={ this.state.slug } type='hidden' className='lg-hidden-field' />
                            <TextField name='env' value={ this.state.env } type='hidden' className='lg-hidden-field' />
                            <TextField name='app' value={ this.state.app } type='hidden' className='lg-hidden-field' />
                            <TextField name='resetLinkId' value={ this.state.resetLinkId } type='hidden' className='lg-hidden-field' />
                            <div className='lg-form-buttons'>
                                <Button variant="contained" type='submit' 
                                    disabled={ !enableSubmit }>{ getI18NMessage('submit') }</Button>
                            </div>
                            <a className='lg-form-hidden'
                                href={`${UI_CONSTANTS.RESET_PW_URL_HASH}`} />
                        </form>
                }
            </React.Fragment>
        )
    }

    onInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    hidePassword(event) {
        const fieldName = event.currentTarget.parentElement.getElementsByClassName('MuiInputBase-input')[0].name;

        this.setState({
            [fieldName === 'password' ? 'newPasswordVisibily' : 'confirmPpasswordVisibily']: false
        })
    }

    showPassword(event) {
        const fieldName = event.currentTarget.parentElement.getElementsByClassName('MuiInputBase-input')[0].name;

        this.setState({
            [fieldName === 'password' ? 'newPasswordVisibily' : 'confirmPpasswordVisibily']: true
        })
    }

    onSubmit(event) {
        event.preventDefault();

        let submitForm = true;
        const { password, confirmpassword } = this.state;

        if ( password !== confirmpassword ) {
            submitForm = false;

            this.setState({
                doNotMatchPasswordError: 'passworddoesnotmatch',
                minPasswordCharError: ''
            })
        } else if ( password.length < 8 ) {
            submitForm = false;

            this.setState({
                minPasswordCharError: 'minpasswordchar',
                doNotMatchPasswordError: ''
            })
        }

        if ( submitForm ) {
            document.getElementById('sso-form-resetpassword').submit();
        }
    }
}

export default ResetPassword;
